/** @type {IApiConfig} */
const config = {
  production: false,
  region: 'th',
  environment: 'test',
  api: 'https://th-test-node.dimorder.com/',
  customerApi: 'https://th-test-customer-api.dimorder.com/',
  // deliveryApi: 'http://localhost:8080/',
  deliveryApi: 'https://th-test-delivery-api.dimorder.com/',
  dimboxApi: 'https://th-box-api.dimorder.com',
  goAdminApi: 'https://th-test-api.dimorder.com/',
  quickPayApi: 'https://th-test-quickpaylink-api.dimorder.com/',
  receipt: 'https://th-test-receipt.dimorder.com/',
  notificationSocketUrl: 'wss://th-test-api.dimorder.com/a/notification/subscribe',
  clientUrl: 'https://th-test.dimorder.com',
  clientNewUrl: 'https://th-test-c.dimorder.com',
  clientWaiterUrl: 'https://th-test.dimorder.com',
  dashboardUrl: 'https://th-test-dimorder-dashboard.web.app',
  reportUrl: 'https://th-test-dimorder-report.web.app',
  mpUrl: 'https://th-test-mp.dimorder.com',
  firebase: {
    apiKey: 'AIzaSyA9cUs1NCEXp_j3J7fs-kj3Y7IHpEYIItw',
    authDomain: 'dimorder-dev-th.firebaseapp.com',
    databaseURL: 'https://dimorder-dev-th-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'dimorder-dev-th',
    storageBucket: 'dimorder-dev-th.firebasestorage.app',
    messagingSenderId: '34634089543',
    appId: '1:34634089543:web:cb66f9010034579036dd62',
    measurementId: 'G-CP8ZXBX629',
  },
}

export default config
